// extracted by mini-css-extract-plugin
module.exports = {"mainPage":"TubylecFeed_mainPage__1T3zF","container":"TubylecFeed_container__Dhs4K","JourneyText":"TubylecFeed_JourneyText__-GkQu","JourneyPost":"TubylecFeed_JourneyPost__TOCy1"};